import content from './content/faq.json';

export const faqMock = {
  name: 'faq',
  layoutType: 1,
  areasList: [
    {
      id: 'faq-main',
      componentName: 'Comp:FaqPage',
      content: JSON.stringify(content)
    }
  ]
};
